var cards = document.querySelectorAll('.product__media-list li .product__media.media.media--transparent');

[...cards].forEach((card) => {
    card.addEventListener('click', function () {
        $('.product__media-list li .product__media.media.media--transparent').removeClass('is_clicked');
        card.classList.toggle('is_clicked');

        let get_url1 = $('.product__media-list li:first-child .product__media.media.media--transparent img').attr('srcset');


        let get_url2 = $('.is_clicked img').attr('srcset');

        // console.log(get_url1, get_url1);

        $('.is_clicked img').attr('srcset', get_url1);
        $('.product__media-list li:first-child .product__media.media.media--transparent img').attr('srcset', get_url2);
    });
});

// transparent header only on home

function desChecker() {
    let productTitleSelector = jQuery('.product__title h1');
    let materialSelector = jQuery("[name='options[Type]']");
    let styleSelector = jQuery("[name='options[Style]']")

    if(!productTitleSelector.length || !materialSelector.length || !styleSelector.length) {
        return;
    }

    let product_title = productTitleSelector.text().trim().replace(/\s+/g, '-').toLowerCase();
    let material = materialSelector.val().replace(/\s+/g, '-').toLowerCase();
    let style = styleSelector.val().replace(/\s+/g, '-').toLowerCase();
    let varDes = product_title + '-' + material + '-' + style;
    $('.' + product_title + '-var_class').hide();
    $('#' + varDes).show();
}

let header_height = '-' + jQuery('sticky-header').height() + 'px';
let top_space = '+' + jQuery('sticky-header').height() + 'px';

if (window.matchMedia("(min-width: 990px)").matches) {
    jQuery(".Yoursy .hero_section").css('padding-top', top_space);
} else {
    jQuery(".Yoursy .hero_section").css('padding-top', 20);
}

// autocompete off

jQuery('.Query #contact_form').attr("autocomplete", "off");

// menu popup toggl


jQuery("#toggl_icon").click(function () {
    jQuery(".footer_section").toggleClass("fix_me");
    jQuery(".cross_footer").toggleClass("d-none");

    if (jQuery(".footer_section").hasClass("fix_me")) {
        bodyScrollLock.disableBodyScroll(jQuery(".footer_section")[0]);
    } else {
        bodyScrollLock.clearAllBodyScrollLocks();
    }
});

jQuery(".cross_footer ").click(function () {
    jQuery(".footer_section").toggleClass("fix_me");
    jQuery(".cross_footer").toggleClass("d-none");

    if (jQuery(".footer_section").hasClass("fix_me")) {
        bodyScrollLock.disableBodyScroll(jQuery(".footer_section")[0]);
    } else {
        bodyScrollLock.clearAllBodyScrollLocks();
    }
});


$(document).ready(function () {


    $('#query-form').on('keyup keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

//     accordion
    var action = 'click';
    var speed = "500";

// Question handler
    $('.faqpage .q').on(action, function () {

        // gets next element
        // opens .a of selected question
        $(this).next().slideToggle(speed)

            // selects all other answers and slides up any open answer
            .siblings('.faqpage .a').slideUp();


    });

//     product disable button when unchecked
    let a = $('.toggl_class_active').hasClass("active");
    if (a) {
        jQuery('.disable_me').css('background', '#193938');
        jQuery('.disable_me').attr('href', '/pages/choose-plan');
    } else {
        jQuery('.disable_me').css('background', 'grey');
        jQuery('.disable_me').attr('href', 'JavaScript:Void(0);');

    }
    $(".toggl_class_active").click(function () {
        a = $('.toggl_class_active ').hasClass("active");
        if (a) {
            jQuery('.disable_me').css('background', '#193938');
            jQuery('.disable_me').attr('href', '/pages/choose-plan');
        } else {
            jQuery('.disable_me').css('background', 'grey');
            jQuery('.disable_me').attr('href', 'JavaScript:Void(0);');
        }
    });

//     product page on change values
    desChecker();
    value1 = jQuery("[name='options[Type]']").val();
    if (value1 == 'Diffuser') {
        jQuery('.on_change_value ').text('Diffuser Essential Oil Blend');
        jQuery('.quantity_product ').text('0.5 fl oz | 15 ml');
    } else {
        jQuery('.on_change_value ').text('Roll On Essential Oil Blend');
        jQuery('.quantity_product ').text('0.3 fl oz | 9 ml');
    }


    jQuery("[name='options[Type]']").change(function () {

        value1 = jQuery("[name='options[Type]']").val();
        if (value1 == 'Diffuser') {
            jQuery('.on_change_value ').text('Diffuser Essential Oil Blend');
            jQuery('.quantity_product ').text('0.5 fl oz | 15 ml');
        } else {
            jQuery('.on_change_value ').text('Roll On Essential Oil Blend');
            jQuery('.quantity_product ').text('0.3 fl oz | 9 ml');
        }

        desChecker();


    });


    jQuery("[name='options[Style]']").change(function () {
        desChecker();
    });
    //     product page on change values closed


    $('#yoursy-store #shopify-section-header ').addClass('home-header');
    $('#yoursy-store #shopify-section-announcement-bar ').addClass('top-header');

    $('#home-02 #shopify-section-header ').addClass('home-header');
    $('#home-02 #shopify-section-announcement-bar ').addClass('top-header');


});


//   add sticky class in header

$(window).scroll(function () {
    let announcementBar = $('#shopify-section-announcement-bar');
    let shopifyHeader = $(' #shopify-section-header');

    if(!shopifyHeader.length) {
        return;
    }

    let announcementBarHeight = 0;


    if(announcementBar.length) {
        announcementBarHeight = announcementBar.height();
    }

    if ($(this).scrollTop() > announcementBarHeight) {
        shopifyHeader.addClass('sticky-header');
        let headerHeight = shopifyHeader.height() + 'px';
        document.documentElement.style.setProperty('--header-height', headerHeight);
    } else {
        shopifyHeader.removeClass('sticky-header');
    }
});

// home scroll bar timeline animation
jQuery(document).ready(function () {
    //declaration

     initHowSection();
     initAnimationSection();
     initTextFadeAndBorderHeightAnimationSections();

    function initTextFadeAndBorderHeightAnimationSections () {
        let selectors = {
            animationSection: '.js-animation-section-container',
            animationSectionBorderHeightAnimateElement: '.js-animation-section-border-height-animate',
            animationSectionTextFadeAnimate: '.js-animation-section-text-fade-animate'
        }

        let animationSections = jQuery(selectors.animationSection);

        if(!animationSections.length) {
            return;
        }

        animationSections.each(function () {
            let windowElement = jQuery(window);
            let animationSection = $(this);

            if(!animationSection.length) {
                return;
            }

            let animationSectionBorderHeightAnimateElement = animationSection.find(selectors.animationSectionBorderHeightAnimateElement);
            let animationSectionTextFadeAnimate = animationSection.find(selectors.animationSectionTextFadeAnimate);

            if(!animationSectionBorderHeightAnimateElement.length && !animationSectionTextFadeAnimate.length) {
                return;
            }

            jQuery(window).scroll(function () {
                let windowHeight = windowElement.innerHeight();
                let windowScrollTop = windowElement.scrollTop();
                let windowScrollBottom = windowScrollTop + windowHeight;
                let animationSectionHeight = animationSection.outerHeight();
                let animationSectionTopDistance = animationSection.offset().top;
                let animationSectionBottomDistance = animationSectionTopDistance + animationSectionHeight;
                let matchMedia = window.matchMedia('(max-width: 768px)');
                let animationBottomSpacing = 35;

                if(matchMedia.matches) {
                    animationBottomSpacing = 70;
                }

                let animationSectionPercentPosition = (((windowScrollBottom - animationSectionBottomDistance + animationSectionHeight - animationBottomSpacing) / animationSectionHeight) * 100);


                if (animationSectionPercentPosition > 100) {
                    animationSectionPercentPosition = 100;
                } else if (animationSectionPercentPosition < 0) {
                    animationSectionPercentPosition = 0;
                }

                if(animationSectionTextFadeAnimate.length) {

                    if (animationSectionPercentPosition > 99) {
                        animationSectionTextFadeAnimate.css({"opacity": '1'});
                    } else {
                        animationSectionTextFadeAnimate.css({"opacity": '1'});
                    }
                }

                if(animationSectionBorderHeightAnimateElement.length) {
                    animationSectionBorderHeightAnimateElement.css({"height": animationSectionPercentPosition + "%"});
                }
            });
        });
    }

    function initHowSection () {
        let sectionHow = jQuery('.section-how');

        if(!sectionHow.length) {
            return
        }

        let distance = sectionHow.offset().top;
        let windowScroll, result, line_height, total_distance;
        let fixedH = sectionHow.height();


        //inscroll funtion
        jQuery(window).scroll(function () {
            if (jQuery(this).scrollTop() >= (distance - 400)) {
                sectionHow.addClass("fixed-css");
            } else {
                sectionHow.removeClass("fixed-css");
            }

            windowScroll = (jQuery(window).scrollTop());
            result = ((windowScroll - distance + 500) / fixedH) * 100;

            if (result > 100) {
                result = 100;
            }

            if (result > 0) {
                jQuery('.dot_1').css({"opacity": '1'});
            } else {
                jQuery('.dot_1').css({"opacity": '0'});
            }


            if (result > 33) {
                jQuery('.dot_2').css({"opacity": '1'});
            } else {
                jQuery('.dot_2').css({"opacity": '0'});
            }

            if (result > 66) {
                jQuery('.dot_3').css({"opacity": '1'});
            } else {
                jQuery('.dot_3').css({"opacity": '0'});
            }

            line_height = result + '%';
            jQuery('.line').css({"height": line_height});
        });
    }

    function initAnimationSection () {
        let sectionAnimation = jQuery('.animation-section');

        if(!sectionAnimation.length) {
            return;
        }

        let distance3 = sectionAnimation.offset().top;
        let windowScroll3, result3, line_height3, total_distance3;
        let fixedH3 = sectionAnimation.height();
        const mediaExtraSmall = window.matchMedia("(max-width: 767px)").matches;

        jQuery(window).scroll(function () {
            if (jQuery(this).scrollTop() >= (distance3 - 400)) {
                sectionAnimation.addClass("fixed-css");
            } else {
                sectionAnimation.removeClass("fixed-css");
            }

            windowScroll3 = (jQuery(window).scrollTop());
            if (mediaExtraSmall) {
                result3 = ((windowScroll3 - distance3 + 700) / fixedH3) * 200;
            } else {
                result3 = ((windowScroll3 - distance3 + 600) / fixedH3) * 120;
            }

            if (result3 > 100) {
                result3 = 100;
            }

            if (result3 > 0) {
                jQuery('.animation-section__row--1').css({"opacity": '1'});
            } else {
                jQuery('.animation-section__row--1').css({"opacity": '0'});
            }

            if (result3 > 33) {
                jQuery('.animation-section__row--2').css({"opacity": '1'});
            } else {
                jQuery('.animation-section__row--2').css({"opacity": '0'});
            }

            if (result3 > 66) {
                jQuery('.animation-section__row--3').css({"opacity": '1'});
            } else {
                jQuery('.animation-section__row--3').css({"opacity": '0'});
            }

            if (result3 > 97) {
                jQuery('.animation-section__image--bottom').css({"opacity": '1'});
            } else {
                jQuery('.animation-section__image--bottom').css({"opacity": '0'});
            }

            line_height3 = result3 + '%';
            jQuery('.line').css({"height": line_height3});
        });
    }


//     accordion

    jQuery(".product__accordion  .is_open ").click(function () {
        $(".product__accordion  details").removeAttr("open");
    });

});

//     accordion on product page
// var cards = document.querySelectorAll('.product__accordion  details');

// [...cards].forEach((card) => {
//     card.addEventListener('click', function () {
//         $(".product__accordion  details").removeClass("is_open");
//         $(".product__accordion  details").removeAttr("open");
//         card.classList.toggle('is_open');
//         $(".product__accordion  details").attr("open");


//     });
// });

//     accordion on product page
var cards = document.querySelectorAll('.product__accordion  details');

cards.forEach((card) => {
    card.addEventListener('click', function (event) {
        if (!event.target.closest('summary')) {
            card.toggleAttribute('open');
        }
    });
});

